import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@tq/ui-components';

import { RpcResponseAnswers, ResponseOverdueForm } from '..';
import { useResponse } from '../../hooks';
import { ConsultationResponseProps } from '../../types';

export const RpcResponse: React.FC<ConsultationResponseProps> = ({ consultation }) => {
  const { t } = useTranslation('consultation_response');

  const { answers } = useResponse(consultation.id);

  return (
    <Box mt={6}>
      <Box px={4}>
        <ResponseOverdueForm consultation={consultation} />
      </Box>
      <Box py={4} px={{ base: 0, sm: 4 }}>
        <h3>
          <strong>{t('review_questions', 'Review questions')}</strong>
        </h3>
      </Box>
      <Box px={{ base: 0, sm: 4 }} mb={6}>
        {t(
          'review_questions_help',
          'Please review the details below and edit or approve the answer(s) as appropriate.'
        )}
      </Box>
      <Box px={{ base: 0, sm: 4 }} mb={6}>
        <RpcResponseAnswers answers={answers} showEdit />
      </Box>
    </Box>
  );
};
